export const SUPPORT_DEFAULT_EMAIL = 'support@luxuryescapes.com'
export const SUPPORT_INDIAN_MARKET_EMAIL = 'support-india@luxuryescapes.com'
export const SUPPORT_INDIAN_MARKET_PREFIX = 'IN'

export const SUPPORT_EMAIL_FOR_BRAND = {
  luxuryescapes: 'support@luxuryescapes.com',
  lebusinesstraveller: 'support@lebusinesstraveller.com',
}
